module.exports = __webpack_public_path__ + "static/media/offline.91595dcf.svg";